import { Contract } from 'ethers';

import {
  beachAbi,
  exchangeRouterAbi,
  PolywaveAbi,
  rSurfTokenAbi,
  surf3dAbi,
  surfTokenAbi,
  titoAbi,
  towelStakeAbi,
  towelTokenAbi,
  waveTokenAbi,
  whirlpoolAbi,
} from './abis';
import { BscProvider, EthProvider, MaticProvider, XDaiProvider } from './providers';
import { ContractAddress, Token } from './types';

export const pancakeSwapContract = new Contract(
  ContractAddress.PancakeSwap,
  exchangeRouterAbi,
  BscProvider
);

// ETH
export const surf3dContract = new Contract(ContractAddress.Surf3d, surf3dAbi, EthProvider);

export const surfTokenEthContract = new Contract(Token.ETH_SURF, surfTokenAbi, EthProvider);

export const titoContract = new Contract(ContractAddress.Tito, titoAbi, EthProvider);

export const whirlpoolContract = new Contract(ContractAddress.Whirlpool, whirlpoolAbi, EthProvider);

// BSC
export const surfTokenBscContract = new Contract(Token.BSC_SURF, surfTokenAbi, BscProvider);

// XDAI
export const surfTokenXDaiContract = new Contract(Token.XDAI_SURF, surfTokenAbi, XDaiProvider);

export const rSurfTokenContract = new Contract(Token.RSURF, rSurfTokenAbi, XDaiProvider);

// MATIC
export const surfTokenMaticContract = new Contract(Token.MATIC_SURF, surfTokenAbi, MaticProvider);

export const beachContract = new Contract(ContractAddress.Beach, beachAbi, MaticProvider);

export const towelStakeContract = new Contract(
  ContractAddress.TowelStake,
  towelStakeAbi,
  MaticProvider
);

export const towelTokenContract = new Contract(Token.TOWEL, towelTokenAbi, MaticProvider);

export const waveTokenContract = new Contract(Token.WAVE, waveTokenAbi, MaticProvider);

export const polywaveContract = new Contract(ContractAddress.Polywave, PolywaveAbi, MaticProvider);
